import { Action, createReducer, on } from '@ngrx/store';
import * as unsubscribeActions from '../action/unsubscribe.action';

export interface UnsubscribeState {
    isDownloading: boolean,
    isDownloadingSuccess: boolean,
    isDownloadingFailure: boolean,
    error: string
}

export const initialState: UnsubscribeState = {
    isDownloading: false,
    isDownloadingSuccess: false,
    isDownloadingFailure: false,
    error: ''
};

const unsubscribeReducer = createReducer(
    initialState,
    on(unsubscribeActions.unsubscribe, () =>
    ({
        isDownloading: true,
        isDownloadingSuccess: false,
        isDownloadingFailure: false,
        error: ''
    })),
    on(unsubscribeActions.unsubscribeSuccess, (_, response) =>
    ({
        isDownloading: false,
        isDownloadingSuccess: true,
        isDownloadingFailure: false,
        error: ''
    })),
    on(unsubscribeActions.unsubscribeFailure, (state, response) =>
    ({
        isDownloading: false,
        isDownloadingSuccess: false,
        isDownloadingFailure: true,
        error: response.error
    }))
)

export function unsubscribe(
    state: UnsubscribeState | undefined,
    action: Action
): UnsubscribeState {
    return unsubscribeReducer(state, action);
}
